module.exports = __webpack_public_path__ + "assets/img/img-course2.6ab9358e.png";